import { clsx } from '../../../ds/clsx';
import { usePortalOverview } from '../api';
import { PageError, PageSkeleton } from '../frame/PageState';
import frame from '../frame/Portal.module.css';
import { UnitsGate } from '../overview/Cards';
import { OwnedUnitCard } from '../overview/OwnerOverview';
import styles from '../overview/Overview.module.css';

/**
 * `/portal/:orgSlug/objects` „Meine Objekte" (no frame): before the purchase the apartments in range of the start
 * page (gated like 14/16), after the purchase the owned unit of 15. Texts for the empty states are own.
 */
export function ObjectsPage() {
  const overview = usePortalOverview();
  if (overview.isPending) return <PageSkeleton blocks={[320]} />;
  if (overview.isError) {
    return (
      <div className={frame.content}>
        <PageError
          what="Ihre Objekte"
          error={overview.error}
          onRetry={() => void overview.refetch()}
          retrying={overview.isFetching}
        />
      </div>
    );
  }
  const data = overview.data;
  return (
    <div className={frame.content}>
      <div className={frame.pageHead}>
        <div>
          <h1 className={frame.pageTitle}>Meine Objekte</h1>
          <div className={frame.pageText}>
            {data.phase === 'after_purchase'
              ? 'Die Wohnung, die Ihnen gehört.'
              : 'Die Wohnungen, die zu Ihrem Finanzierungsvolumen passen.'}
          </div>
        </div>
      </div>
      <div className={styles.overview}>
        {data.phase === 'after_purchase' ? (
          data.unit ? (
            <OwnedUnitCard unit={data.unit} withObjectLink={false} />
          ) : (
            <EmptyObjects text="Zu Ihrem Kauf liegen noch keine Objektangaben vor." />
          )
        ) : data.units ? (
          <UnitsGate units={data.units} />
        ) : (
          <EmptyObjects text="Sobald Ihr Finanzierungsvolumen feststeht, sehen Sie hier die Wohnungen in Ihrem Rahmen." />
        )}
      </div>
    </div>
  );
}

function EmptyObjects({ text }: { text: string }) {
  return (
    <div className={clsx(frame.card, frame.errorCard)}>
      <p className={frame.errorText}>{text}</p>
    </div>
  );
}
